import { inject, injectable } from 'inversify';
import { type IDispatcher } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';
import DITypes from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr/DITypes';
import Request from '@framework/api/Rpc/Request';
import BaseRepository from '@/creditflowresearch/infrastructure/repository/BaseRepository';
import { ISearchResult } from '@/creditflowresearch/domain/vo/ISearch';

@injectable()
class HeaderRepository extends BaseRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) protected readonly rpc: IDispatcher,
  ) {
    super(rpc);
  }

  search = async (searchString: string): Promise<ISearchResult> => this.abortableCall(
    new Request('finsight_web.frontend.finsight.get_search', { searchString }),
  );

  searchDeals = async (searchString: string) => this.abortableCall(
    new Request('finsight_web.market.search.deals', { searchString }),
  );
}

export default HeaderRepository;
